<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">{{ location }}</h2>
      <span>|</span>
      <h2 class="title title-primary">
        {{ $t("lang.online.order_boxes.page_title_line_1") }}
      </h2>
      <span>|</span>
      <h3 class="title title-primary">
        {{ $t("lang.online.order_boxes.page_title_line_2") }}
      </h3>
    </div>
    <div class="page-header">
      <div class="boxes" v-if="!shouldLoading">
        <bx-box
          dark
          color="outline"
          :title="$t('lang.online.order_boxes.box_title_1')"
          class="col-12 col-md-6 col-lg-auto p-1"
        >
          <template slot="actions">
            <bx-order-status :status="order_status" dark></bx-order-status>
          </template>
          <div class="detail-titles">
            <div class="wrapper">
              <h4>
                Nº
                <strong>{{ id }}</strong>
              </h4>
              <h5>
                <strong>{{ name }}</strong>
              </h5>
            </div>
          </div>
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.online.order_boxes.box_label_2')"
            :value="exitTime"
            font-size="xs"
          />
        </bx-box>

        <bx-box
          dark
          color="outline"
          class="col-6 col-md-4 col-lg-auto p-1 bx-box-adjustable"
        >
          <bx-value
            :label="$t('lang.online.order_boxes.box_label_3')"
            :value="waitingTime"
            font-size="xs"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-md-4 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.online.order_boxes.box_label_4')"
            :value="`${this.real_item_count} / ${this.item_count}`"
            font-size="xs"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-md-4 col-lg-auto p-1">
          <bx-value
            label="Cajas"
            :value="`${this.num_verified_boxes} / ${this.num_boxes}`"
            font-size="xs"
          />
        </bx-box>
      </div>
      <skeleton-boxes :boxes="5" v-else />
    </div>

    <div class="page-main-content">
      <div class="container-fluid">
        
        <div class="row" style="margin: 8px">
          <bx-btn @click="$router.back()">{{
            $t("lang.messages.go_back")
          }}</bx-btn>
        </div>
        <div class="row">
          <div class="col-12">
            <bx-box
              :title="
                itemCount + ' ' + $t('lang.online.order_boxes.table_title')
              "
              color="white"
              no-padding
              :loading="shouldLoading"
            >
              <template v-slot:default>
                <bx-table
                  :data="data"
                  :columns="columns"
                  paginated
                  v-if="!shouldLoading"
                  backendPagination
                  :currentPage="page"
                  :perPage="itemsPerPage"
                  :total="itemCount"
                  @update:currentPage="updatePage"
                  @search="onSearch"
                >
                  <template slot-scope="props">
                    <bx-table-column field="box_status" centered>
                      <bx-box-status
                        :status="props.row.box_status"
                      ></bx-box-status>
                    </bx-table-column>
                    <bx-table-column>
                      <router-link
                        :to="`/online/order/${id}/box/${props.row.id}/detail`"
                        class="bx-link bx-link-bold"
                        >{{ props.row.barcode }}</router-link
                      >
                    </bx-table-column>
                    <bx-table-column>{{
                      formatDate(props.row.exit_time)
                    }}</bx-table-column>
                    <bx-table-column>{{
                      props.row.theorical_item_count
                    }}</bx-table-column>
                    <bx-table-column>{{
                      props.row.real_item_count
                    }}</bx-table-column>
                    <bx-table-column>{{
                      props.row.references
                    }}</bx-table-column>
                    <bx-table-column>
                      <router-link
                        class="bx-link bx-link-bold"
                        :to="{
                          name: 'Sale_BoxVerificationView',
                          params: { orderId: id, id: props.row.id }
                        }"
                      >
                        {{ props.row.verification_count }}
                      </router-link>
                    </bx-table-column>
                    <bx-table-column>
                      <bx-complementary-mini
                        :percent="props.row.ratingPercent"
                      ></bx-complementary-mini>
                    </bx-table-column>
                 <bx-table-column
                  ><v-icon color="red" @click="deleteClick(props)" 
                    >mdi-delete</v-icon
                  ></bx-table-column>
                  </template>
                </bx-table>
              </template>
            </bx-box>
          </div>
        </div>
        <v-row class="d-flex d-sm-none">
          <div
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="busy"
            infinite-scroll-distance="20"
            style="width: 100%"
          >
            <v-list width="100%">
              <v-list-item
                two-line
                v-for="(item, index) in dataList"
                :key="index"
                class="green lighten-5 ma-2 rounded-lg"
                ripple
                :to="`/online/order/${id}/box/${item.id}/detail`"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    <div>
                      {{ item.barcode }}
                    </div>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-subtitle class="text-caption">
                    {{ item.real_item_count + "/" + item.theorical_item_count }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-caption">
                    {{ item.reception_time }}
                  </v-list-item-subtitle>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </v-row>
        <skeleton-table :columns="8" v-if="shouldLoading" />
      </div>
    </div>
    <v-dialog v-model="confirmDialog" persistent scrollable width="600px">
      <v-card>
        <v-card-title>
          <h4 class="mt-3 w-100 text-left">{{$t("lang.inventory.detail.confirm_delete")}}</h4>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-10" color="#9bc31c" @click="onCancel" dark>
            No
          </v-btn>
          <v-btn class="mr-5" color="#9bc31c" @click="removeBox" dark>
            {{ $t("lang.inventory.detail.yes") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BxTable from "../../../bx-components/BxTable";
import BxTableColumn from "../../../bx-components/BxTableColumn";
import BxBtn from "../../../bx-components/BxBtn";
import BxOrderStatus from "../../../bx-components/BxOrderStatus";
import common from "@/utils/common";

import moment from "moment";
export default {
  name: "inbound-order-detail",
  components: { BxOrderStatus, BxBtn, BxTableColumn, BxTable },
  mixins: [common],
  props: {
    id: {
      type: [Number, String]
    }
  },
  data() {
    return {
      key: "online_order_box_detail",
      shouldLoading: true,
      columns: [],
      data: [],
      dataList: [],
      orderData: null,
      exitTime: "",
      waitingTime: "",
      itemCount: "",
      confirmDialog: false,
      name: "",
      props:null,
      order_status: 0,
      contents: [],
      reloadInterval: null,
      API_BASE: process.env.VUE_APP_API_BASE,
      itemsPerPage: process.env.VUE_APP_ORDER_BOXES_PER_PAGE,
      page: 1,
      filters: {
        box__codebar__contains: null
      }
    };
  },
  computed: {
    location() {
      return localStorage.getItem("location");
    }
  },
  methods: {
    onCancel() {
      this.confirmDialog = false;
    },
    deleteClick(props) {
      this.props=props
      this.confirmDialog = true;
    },

     async removeBox() {
        var box=await this.$api.reception_boxes.get_boxes_by_barcode(this.props.row.barcode);
      try {
        await this.$api.reception_boxes.deleteBox(box[0].id);
        this.data.splice(this.props.index, 1);
      } catch (error) {
        console.error(error);
      }
      this.onCancel()
    },
    loadMore() {
      if (
        !this.shouldLoading &&
        this.dataList.length &&
        this.dataList.length < this.itemCount &&
        this.isMobile
      ) {
        this.page++;
        this.getData();
      }
    },
    formatDate(date) {
      return date
        ? moment(date).format("DD/ MM/ YYYY, h:mm a")
        : this.$t("lang.messages.no_date_available");
    },
    onSearch(field, value) {
      this.$session.set(this.key + field, value);

      switch (field) {
        case "barcode":
          this.filters.barcode = value;
          this.getData();
          break;
      }
    },
    updatePage(p) {
      this.page = p;
      this.getData(this.locationId);
    },
    async getData() {
      try {
        if (this.isMobile) {
          this.shouldLoading = true;
        }
        this.orderData = await this.$api.orders.get(this.id);
        this.exitTime = this.orderData.exit_date;
        this.order_status = this.orderData.destination_status;
        this.waitingTime = this.orderData.waiting_time;
        this.name = this.orderData.order_name;
        this.num_boxes = this.orderData.num_boxes;
        this.num_verified_boxes = this.orderData.num_verified_boxes;
        this.real_item_count = this.orderData.real_item_count;
        this.item_count = this.orderData.item_count;

        this.report_boxes = await this.$api.orders.report_boxes(this.id, {
          offset: (this.page - 1) * this.itemsPerPage,
          limit: this.itemsPerPage,
          box__codebar__contains: this.filters.barcode
        });

        this.itemCount = this.report_boxes.count;
        this.data = this.report_boxes.results.map((item, key) => {
          let rating = (item.real_item_count / item.theorical_item_count) * 100;
          if (rating > 100) {
            rating = 0;
          }
          return {
            id: item.id,
            box_status: item.status,
            barcode: item.barcode,
            exit_time: item.reading_time,
            theorical_item_count: item.theorical_item_count,
            real_item_count: item.real_item_count,
            references: item.references,
            verification_count: item.verification_count,
            ratingPercent: rating
          };
        });
        if (this.isMobile) {
          this.dataList = this.dataList.concat(this.data);
        }
        this.columns = [
          {
            field: "box_status",
            label: this.$t("lang.online.order_boxes.table_field_1"),
            centered: true,
            width: 80
          },
          {
            field: "barcode",
            label: this.$t("lang.online.order_boxes.table_field_2"),
            filter: {
              placeholder: this.$t(
                "lang.online.order_boxes.table_field_placeholder_2"
              ),
              value: this.filters.barcode,
              isdate: false
            }
          },
          {
            field: "exit_time",
            label: this.$t("lang.online.order_boxes.table_field_3")
          },
          {
            field: "theorical_item_count",
            label: this.$t("lang.online.order_boxes.table_field_4")
          },
          {
            field: "real_item_count",
            label: this.$t("lang.online.order_boxes.table_field_5")
          },
          {
            field: "references",
            label: this.$t("lang.online.order_boxes.table_field_6")
          },
          {
            field: "verification_count",
            label: this.$t("lang.online.order_boxes.table_field_7")
          },
          {
            field: "ratingPercent",
            label: this.$t("lang.online.order_boxes.table_field_8"),
            width: 200
          },
          {
              field: "action",
              label: this.$t("lang.inbound.dashboard.table_field_11"),
              centered: true
          }
        ];
      } catch (error) {
        console.log(error);
      } finally {
        this.shouldLoading = false;
      }
    }
  },
  mounted() {
    if (!this.isMobile) {
      this.reloadInterval = setInterval(
        this.getData,
        process.env.VUE_APP_RELOAD_TIME
      );
    }
    this.filters.barcode = this.$session.get(this.key + "barcode");
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  }
};
</script>
<style scoped>
@media screen and (max-width: 480px) {
  .bx-box-adjustable >>> .bx-box-content {
    min-height: 95px;
  }

  .bx-box-adjustable >>> .bx-value-value {
    margin-top: 10px;
  }
}
</style>
